
<form [formGroup]="form" autocomplete="off">

    <p-dialog showHeader="false" [(visible)]="display" [modal]="true" width="700" [baseZIndex]="10000"
              header="Buscador de Especies" (onShow)="showDialogMaximized(dialDetail)"
              (onHide)="emitArraySelectedEspeciesEppo($event, arraySelectedEspeciesEppo)" #dialDetail>


        <div class="animated fadeIn">

            <div class="row pb-2">
                <div class="col-md-12">
                    <span *ngIf="existeParametroGrupo" class="label-dialog-cexveg">{{DescripcionGrupo | truncate:[225, '...']}}</span>
                    <br />
                    <span class="label-dialog-cexveg">{{DescripcionForma}}</span>
                    <br />
                    <span class="label-dialog-cexveg">{{DescripcionSubForma}}</span>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">

                    <div class="card card-accent-success animated fadeIn">

                        <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Filtros
                                <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">

                            <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                            <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                                <div class="row">
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="inpCodigo">Código Eppo</label>
                                        <input formControlName="CodigoEppo" name="CodigoEppo" maxlength="50" title="" class="form-control" id="inpCodigo" type="text" value="">
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="inpDescripcion">Nombre Botánico</label>
                                        <input formControlName="NombreBotanico" name="NombreBotanico" maxlength="150" title="" class="form-control" id="inpDescripcion" type="text" value="">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" for="inpDescripcion">Nombre Común</label>
                                        <input formControlName="NombreComun" name="NombreComun" maxlength="100" title="" class="form-control" id="inpDescripcion" type="text" value="">
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="inpDescripcion">Favorito</label>
                                        <p-selectButton class="selectButtonCust"
                                                        [options]="listSiNoTodos"
                                                        formControlName="Favorito"
                                                        unselectable="true">
                                        </p-selectButton>
                                    </div>
                                </div>

                                <div class="row" style="margin-top: 8px;">
                                    <div class="col-md-12">
                                        <div class="form-group-0 float-right">

                                            <div class="btn-group">
                                                <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                            </div>

                                            <div class="btn-group">
                                                <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--GRID DATOS-->
            <div *ngIf="searchingButton" class="row">
                <div class="col-md-12">
                    <div *ngIf="!isModeSelectionRowsCheckBoxes" class="label-msg-info m-1">
                        <i class="fa fa-info-circle fa-lg"></i> Haga doble click para seleccionar una Especie
                    </div>
                    <div *ngIf="isModeSelectionRowsCheckBoxes" class="label-msg-info label-dialog-cexveg">
                        <i class="fa fa-info-circle fa-lg"></i>  <ins>NOTA: Marque las Especies a seleccionar y cierre esta pantalla</ins>
                    </div>
                    <div class="card card-accent-success">
                        <div class="card-header-buscador">
                            <i class="fa fa-align-justify"></i> Resultado de la búsqueda
                        </div>

                        <!-- GRID ROW SELECTION MODE: DOBLE CLIC (SINGLE) -->
                        <div *ngIf="!isModeSelectionRowsCheckBoxes" class="card-body">

                            <p-table #tableSearch autoLayout="true" [value]="resultEspecieEppo?.ResultList" [columns]="cols"
                                     selectionMode="single" [(selection)]="selectedCodigoEppo" dataKey="Id"
                                     [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                     [rows]="resultEspecieEppo?.PageSize" [totalRecords]="resultEspecieEppo?.TotalCount" [loading]="loading"
                                     [ngClass]="displayGridHidden(resultEspecieEppo.ResultList)"
                                     styleClass="table table-responsive-sm  table-sm">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                    <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" (click)="onSelect(rowData)" (dblclick)="onRowDblClick($event, rowData)">
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="col.field!=='Favorito'">
                                                {{rowData[col.field]}}
                                            </span>
                                            <span *ngIf="col.field==='Favorito'">
                                                {{rowData[col.field] | siNo}}
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <div *ngIf="tableSearch?.totalRecords" class="p-2">Se han encontrado {{ tableSearch?.totalRecords  | number:'1.0-0':'es-ES' }} registros</div>
                            <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                        </div>

                        <!-- GRID ROW SELECTION MODE: CHECKBOXES (MUTIPLE) -->
                        <div *ngIf="isModeSelectionRowsCheckBoxes" class="card-body">

                            <p-table #tableSearch autoLayout="true" [value]="resultEspecieEppo?.ResultList" [columns]="cols"
                                     selectionMode="multiple" [(selection)]="arraySelectedEspeciesEppo" dataKey="Id"
                                     [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                     [rows]="resultEspecieEppo?.PageSize" [totalRecords]="resultEspecieEppo?.TotalCount" [loading]="loading"
                                     [ngClass]="displayGridHidden(resultEspecieEppo?.ResultList)"
                                     styleClass="table table-responsive-sm  table-sm">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th class="th-md">
                                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                        </th>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr>
                                        <td>
                                            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                        </td>
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="col.field!=='Favorito'">
                                                {{rowData[col.field]}}
                                            </span>
                                            <span *ngIf="col.field==='Favorito'">
                                                {{rowData[col.field] | siNo}}
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>

                            <div *ngIf="tableSearch?.totalRecords" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                            <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <p-footer>
            <button pButton (click)="acceptDialog()" [disabled]="noAccepted()" label="Aceptar" class="p-confirm-dialog-accept" icon="pi pi-check" title="Aceptar"></button>
            <button pButton (click)="cancelDialog()" label="Cancelar" class="p-confirm-dialog-reject" icon="pi pi-times" title="Cancelar"></button>
        </p-footer>

    </p-dialog>
</form>
